import { render, staticRenderFns } from "./ShopAssignmentSingle.vue?vue&type=template&id=26befaaf&scoped=true&"
import script from "./ShopAssignmentSingle.vue?vue&type=script&lang=js&"
export * from "./ShopAssignmentSingle.vue?vue&type=script&lang=js&"
import style0 from "./ShopAssignmentSingle.vue?vue&type=style&index=0&id=26befaaf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26befaaf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VIcon,VRow})
